import { withState } from 'recompose';

export default withState('removeAccountInfo', 'updateRemoveAccountInfo', {});
